module.exports = __webpack_public_path__ + "img/主营业务_软件产品中心07.6ca3b94d.png";